import {TextSelection} from '@mintdata/mint-kit/api/models/Text';

export interface IFocusActivator
{
    focus();
}

export interface ITextFocusActivator extends IFocusActivator
{
    getText():string;
    setText(value:string):void;
}

export interface ISelectionTextFocusActivator extends ITextFocusActivator
{
    getSelection():TextSelection;
    setSelection(value:TextSelection):void;
}

export class FocusUtil
{
    public static focusActivator(boundFocusFn:() => (any)):IFocusActivator
    {
        return {
            focus: boundFocusFn,
        };
    }

    public static textFocusActivator(boundFocusFn:() => (any),
                                     boundGetTextFn:() => string,
                                     boundSetTextFn:(value:string) => void):ITextFocusActivator
    {
        return {
            focus: boundFocusFn,
            getText: boundGetTextFn,
            setText: boundSetTextFn,
        };
    }

    public static selectionTextFocusActivator(boundFocusFn:() => (any),
                                              boundGetTextFn:() => string,
                                              boundSetTextFn:(value:string) => void,
                                              boundGetSelectionFn:() => TextSelection,
                                              boundSetSelectionFn:(value:TextSelection) => void):ISelectionTextFocusActivator
    {
        return {
            focus: boundFocusFn,
            getText: boundGetTextFn,
            setText: boundSetTextFn,
            getSelection: boundGetSelectionFn,
            setSelection: boundSetSelectionFn,
        };
    }
}
